import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  container: {
    margin: '2% auto 5%',
    width: '100%',
    maxWidth: '915px',
    padding: '0 10px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '42px',
    color: '#000000',
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.2',
    marginTop: '0',
    marginBottom: '20px'
  },
  content: {
    lineHeight: '1.5',
    paddingBottom: '20px'
  }
}));

const AboutUsWelcomeSectionPreview = ({mainContentHeading, mainContentText}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.title}>{mainContentHeading}</div>
      <div
        className={classes.content}
        dangerouslySetInnerHTML={{__html: mainContentText}}
      />
    </div>
  );
};

export default AboutUsWelcomeSectionPreview;
